"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.LinkContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../utils");

var LinkContainer = _styledComponents.default.a.withConfig({
  displayName: "LinkContainer",
  componentId: "sc-oq1wsm-0"
})(["text-decoration:underline;svg{width:", ";height:", ";margin-left:", ";}"], (0, _utils.pxToRem)(12), (0, _utils.pxToRem)(12), (0, _utils.pxToRem)(4));

exports.LinkContainer = LinkContainer;